import { render } from "./SelectorMenu.vue?vue&type=template&id=61b7d32f&scoped=true"
import script from "./SelectorMenu.vue?vue&type=script&lang=js"
export * from "./SelectorMenu.vue?vue&type=script&lang=js"

import "./SelectorMenu.vue?vue&type=style&index=0&id=61b7d32f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b7d32f"]])

export default __exports__